if (!customElements.get('healthy-menu')) {
  customElements.define('healthy-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-hl-menu-open]');
      this.trigger.addEventListener('click', () => {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
      this.querySelector('[data-hl-menu-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.focus();
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
      }
    }
  });
}

if (!customElements.get('healthy-hero')) {
  customElements.define('healthy-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-hl-slide]')];
      this.dots = [...this.querySelectorAll('[data-hl-dot]')];
      this.pauseButton = this.querySelector('[data-hl-pause]');
      this.index = 0;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motionQuery.matches;
      this.hovered = false;
      this.focused = false;
      this.querySelector('.hl-hero__controls').hidden = false;
      this.dots.forEach((button, index) => button.addEventListener('click', () => { this.show(index); this.schedule(); }));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); this.schedule(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); });
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
      this.visibilityHandler = () => this.schedule();
      this.motionHandler = (event) => { this.paused = event.matches; this.updateButton(); this.schedule(); };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.motionQuery.addEventListener('change', this.motionHandler);
      this.updateButton();
      this.schedule();
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
      this.dots.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    updateButton() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.pauseButton.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => { this.show((this.index + 1) % this.slides.length); this.schedule(); }, 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.motionQuery?.removeEventListener('change', this.motionHandler);
    }
  });
}
